import { ButtonBlockNode } from '@prezly/story-content-format';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export function ButtonBlock(_ref) {
  var {
    node
  } = _ref;
  var {
    href,
    label,
    layout,
    new_tab: newTab,
    variant
  } = node;
  if (!href) {
    return null;
  }
  return /*#__PURE__*/_jsx("a", {
    className: classNames('prezly-slate-button-block', {
      'prezly-slate-button-block--outlined': variant === ButtonBlockNode.Variant.OUTLINE,
      'prezly-slate-button-block--wide': layout === ButtonBlockNode.Layout.WIDE,
      'prezly-slate-button-block--right': layout === ButtonBlockNode.Layout.RIGHT,
      'prezly-slate-button-block--left': layout === ButtonBlockNode.Layout.LEFT,
      'prezly-slate-button-block--center': layout === ButtonBlockNode.Layout.CENTER
    }),
    href: href,
    rel: newTab ? 'noreferrer noopener' : undefined,
    target: newTab ? '_blank' : undefined,
    children: label
  });
}